import { IdType, RequestVM } from 'civil-status/view-models/step-form';
import { Fragment, memo } from 'react';
import CheckboxRequest from './checkbox';
import RadioRequest from './radio';
import SelectRequest from './select';

interface ComponentToRequestProps {
  request?: RequestVM;
  disabled?: boolean;
}

const ComponentToRequestComponent = ({
  request,
  disabled,
}: ComponentToRequestProps): React.ReactElement => {
  switch (request?.type) {
    case IdType.Checkbox:
      return <CheckboxRequest request={request} disabled={disabled} />;

    case IdType.Radio:
      return <RadioRequest request={request} disabled={disabled} />;

    case IdType.Select:
      return <SelectRequest request={request} required disabled={disabled} />;

    default:
      return <Fragment></Fragment>;
  }
};

ComponentToRequestComponent.displayName = 'Component To Request';

const ComponentToRequest = memo(ComponentToRequestComponent);

export default ComponentToRequest;
